module.exports = __webpack_public_path__ + "images/ce08ba9c576c197ece15f95137236553.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/travel_addict_logo.png
// module id = 571
// module chunks = 0